function initQtips() {
    $(document).find('.qtooltip').each(function () {
        console.log('before');
        if ($(this).attr('data-hasqtip')) {
            return;
        }
        var value = $(this).data('qtext');
        var source = $(this).data('qsource');
        console.log(source);
        if (source) {
            var value = $(document).find("#" + source).html();
        }

        $(this).qtip({
                content: {
                    text: value,
                },
                style: {
                    classes: 'qtip-bootstrap',
                },
                position: {
                    my: 'top center',  // Position my top left...
                    at: 'bottom center', // at the bottom right of...
                },
                show: {
                    delay: 100
                },
                hide: {
                    fixed: true,
                    delay: 100
                }
            }
        );

    });
}

$(document).ready(function () {
    initQtips();
});

$(document).ajaxComplete(function () {
    delay(function () {
        initQtips();
    }, 400);
});